"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adminPassword = void 0;
var qs = require("qs");
// [Admin-Password]
exports.adminPassword = function (axios) {
    return {
        putAdminsPassword: function (request) {
            return axios.put('/admins/password', request.data);
        },
        putAdminsPasswordDate: function () {
            return axios.put('/admins/password/date');
        },
        putAdminsPasswordByKey: function (request) {
            return axios.put('/admins/password/key', request.data);
        },
        getAdminsPasswordDate: function () {
            return axios.get('/admins/password/date');
        },
        postAdminsPasswordEmail: function (request) {
            return axios.post('/admins/password/email', request.data);
        },
        getAdminsPasswordKeyValidate: function (request) {
            var query = qs.stringify(request.params);
            return axios.get("/admins/password/key/validate?" + query);
        },
    };
};
